/** Enum that contains the possible button styles. */
enum RibbonButtonSize {
  TextOnly,
  SmallIcon,
  SmallIconWithText,
  LargeIcon,
  LargeIconWithText,
  DropDown,
}

export default RibbonButtonSize;
